module.exports = __webpack_public_path__ + "media/Images/icon-blue-money-hand-o-e82871fa33a80df0257876d080849cdf.svg";